(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setRestHeight();
      this.watchAnnouncementBar();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      /* El logo puede no estar cargado en el connectedCallback: re-medimos en
         load y al redimensionar (debounce, el offsetHeight fuerza reflow). */
      this.onLoadHandler = this.setRestHeight.bind(this);
      this.onResizeHandler = () => {
        clearTimeout(this.restHeightTimer);
        this.restHeightTimer = setTimeout(this.setRestHeight.bind(this), 100);
      };
      window.addEventListener('load', this.onLoadHandler);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /* Altura del header SIN compactar. Cuando se compacta, el .header-wrapper
       pasa a position:fixed y la seccion conserva esta altura en el flujo (ver
       assets/custom-header.css), asi la pagina no salta los ~60px que se achica
       la barra. Solo se mide en estado no compactado. */
    setRestHeight() {
      if (this.header.classList.contains('scrolled-past-header')) return;
      document.documentElement.style.setProperty('--header-rest-height', `${this.header.offsetHeight}px`);
    }

    /* La barra de anuncios queda sticky arriba de todo (ver
       assets/custom-header.css) y el header compactado se cuelga de
       --announcement-height para apoyarse justo debajo. No alcanza con
       medirla una vez: la barra rota mensajes de distinta altura (40px /
       60px), asi que la seguimos con un ResizeObserver. */
    watchAnnouncementBar() {
      this.announcementBar = document.querySelector('.announcement-bar-section');
      if (!this.announcementBar) return;

      this.setAnnouncementHeight = () => {
        document.documentElement.style.setProperty(
          '--announcement-height',
          `${Math.round(this.announcementBar.getBoundingClientRect().height)}px`
        );
      };

      this.setAnnouncementHeight();

      if (!('ResizeObserver' in window)) return;
      this.announcementObserver = new ResizeObserver(this.setAnnouncementHeight);
      this.announcementObserver.observe(this.announcementBar);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.onLoadHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      clearTimeout(this.restHeightTimer);
      if (this.announcementObserver) this.announcementObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    const testCookieValue = getCookie('testCookie');
        if (testCookieValue) {
            document.cookie = 'testCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        } else{
      
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (this.preventHide) return;
              requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
              } else {
                window.clearTimeout(this.isScrolling);
      
                this.isScrolling = setTimeout(() => {
                  this.preventReveal = false;
                }, 66);
      
                requestAnimationFrame(this.hide.bind(this));
              }
            } else if (scrollTop <= this.headerBounds.top) {
              this.header.classList.remove('scrolled-past-header');
              this.setRestHeight();
              requestAnimationFrame(this.reset.bind(this));
            }
      
            this.currentScrollTop = scrollTop;
          }
          
          }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();
})();
